import MainPriceMobile from './MainPriceMobile';

export default MainPriceMobile;
